import script from "./FretboardSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./FretboardSettings.vue?vue&type=script&setup=true&lang=ts"

import "./FretboardSettings.vue?vue&type=style&index=0&id=3d901df7&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d901df7"]])

export default __exports__